import { IconButton } from '@/Domain/components/Shared/Button/Button';
import { useSidebar } from '@/Domain/components/Shared/Sidebar/Sidebar';
import { PanelLeftCloseIcon } from '@/Domain/components/icons/PanelLeftCloseIcon';
import { PanelLeftOpenIcon } from '@/Domain/components/icons/PanelLeftOpenIcon';
import { QuickChatLogoFull, QuickChatLogoIcon } from '@/Domain/components/icons/QuickChatLogo.icon';

export function SidebarLogo() {
  const { state, toggleSidebar, isMobile } = useSidebar();
  // On mobile, always show expanded logo since the Sheet is full-width
  const isCollapsed = state === 'collapsed' && !isMobile;

  return (
    <div className="flex items-center justify-between">
      {isCollapsed ? (
        <div className="relative flex items-center justify-center w-full h-6">
          <QuickChatLogoIcon className="mt-1 size-6 text-sidebar-foreground transition-opacity duration-200 group-hover:opacity-0" />
          <IconButton
            onClick={toggleSidebar}
            variant="ghost"
            size="sm"
            className="absolute inset-0 flex items-center justify-center rounded-md text-muted-foreground opacity-0 transition-opacity duration-200 hover:text-sidebar-foreground group-hover:!opacity-100"
          >
            <PanelLeftOpenIcon size={16} />
          </IconButton>
        </div>
      ) : (
        <>
          <QuickChatLogoFull className="ml-1.5 h-5.5 animate-in text-sidebar-foreground transition-opacity duration-200 slide-in" />
          <IconButton
            variant="ghost"
            size="sm"
            onClick={toggleSidebar}
            className="rounded-md text-muted-foreground hover:text-sidebar-foreground"
          >
            <PanelLeftCloseIcon size={16} />
          </IconButton>
        </>
      )}
    </div>
  );
}
